<div class="console-panel">
  <!-- Console Header -->
  <div class="console-panel__header d-flex align-items-center gap-2 mb-2">
    <span class="console-panel__led console-panel__led--green"></span>
    <span class="console-panel__led console-panel__led--yellow"></span>
    <span class="console-panel__led console-panel__led--red"></span>
    <span class="console-panel__title ms-2">SELECT AGENT</span>
  </div>

  <!-- Console Screen -->
  <div class="console-panel__screen">
    <mat-form-field class="w-100 console-panel__field">
      <mat-select
        #singleSelect
        disableOptionCentering
        [required]="required"
        [formControl]="agentCtrl"
        [placeholder]="placeholder"
      >
        <!-- Selected value display — username only, no avatar -->
        <mat-select-trigger>
          {{ agentCtrl.value?.userData?.nickname || agentCtrl.value?.username }}
        </mat-select-trigger>

        <!-- Search row -->
        <mat-option class="console-panel__search-option">
          <ngx-mat-select-search [formControl]="agentsFilterCtrl" [placeholderLabel]="placeholderLabel">
            <mat-icon ngxMatSelectSearchClear *ngIf="!isFinding">close</mat-icon>
            <mat-icon ngxMatSelectSearchClear *ngIf="isFinding">
              <mat-progress-spinner matSuffix mode="indeterminate" diameter="20"></mat-progress-spinner>
            </mat-icon>
          </ngx-mat-select-search>
        </mat-option>

        <!-- Agent options -->
        <mat-option
          class="console-panel__option"
          *ngFor="let agent of filteredAgents | async; trackBy: trackItem"
          [value]="agent"
        >
          <div class="d-flex align-items-center gap-2 w-100">
            <span class="console-panel__option-dot"></span>
            <app-user-template [user]="agent" tooltipField="userData.status"></app-user-template>
            <div
              *ngIf="withTeam && agent.team"
              class="d-flex align-items-center gap-1 ms-auto console-panel__team-badge"
            >
              <div class="console-panel__team-icon" *ngIf="agent.team?.icon">
                <app-s3-image [image]="agent.team?.icon"></app-s3-image>
              </div>
              <span class="console-panel__team-name">{{ agent.team?.name }}</span>
            </div>
          </div>
        </mat-option>
      </mat-select>

      <!-- Clear button -->
      <button
        mat-icon-button
        matSuffix
        *ngIf="agentCtrl.value"
        [attr.aria-label]="'BUTTON.CLEAR' | translate"
        (click)="resetAgent($event)"
        class="console-panel__clear-btn"
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-hint *ngIf="hint" class="console-panel__hint">{{ hint }}</mat-hint>
      <mat-error *ngIf="errorLabel" class="console-panel__error">{{ errorLabel }}</mat-error>
    </mat-form-field>
  </div>
  <!-- /.console-panel__screen -->

  <!-- Loading bar -->
  <div class="console-panel__loader-wrap" *ngIf="isLoading" [@fadeInOut]>
    <mat-progress-bar mode="indeterminate" class="console-panel__loader"></mat-progress-bar>
    <span class="console-panel__loader-label">SCANNING…</span>
  </div>
</div>
